
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M.75 23.25h18"}}),_c('circle',{staticClass:"a",attrs:{"cx":"21","cy":"3","r":"2.25"}}),_c('path',{staticClass:"a",attrs:{"d":"M21 5.25v15M23.25 18.75h-7.5M15.75 15.75h-3l-1.5 3h-3l-1.5-3h-3v7.5h12v-7.5zM8.25 6.75a7.5 7.5 0 00-7.5 7.5v1.5h7.5zM11.25 6.75a7.5 7.5 0 017.5 7.5v1.5h-7.5z"}})])
          )
        }
      }
    